import { CommonModule } from '@angular/common';
// Modules
import { ConvertModalModule } from 'ConverterApp/features/convert-modal/convert-modal.module';
import * as i0 from "@angular/core";
export class LegacyAssetConversionCheckerModule {
}
LegacyAssetConversionCheckerModule.ɵfac = function LegacyAssetConversionCheckerModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || LegacyAssetConversionCheckerModule)(); };
LegacyAssetConversionCheckerModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: LegacyAssetConversionCheckerModule });
LegacyAssetConversionCheckerModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, ConvertModalModule] });
